import {forwardRef} from "react";
import {customerApi} from "~/api";
import {DebounceSelect} from "../index";

const SelectCustomer = forwardRef(({ options, errors, ...props }, ref) =>
{
	const onSearchCustomer = async (keyword) =>
	{
		const response = await customerApi.options({keyword, limit: 300});

		return response.data.map((customer) => ({
			label: `${customer.code} ${customer.name}`,
			value: customer.id,
		}))
	}

	return (
		<DebounceSelect fetchOptions={onSearchCustomer} errors={errors} optionsDefault={options} {...props}/>
	)
});

export default SelectCustomer;